import {
  type AnnotationModeConfig,
  DEFAULT_DISPLAY_STATE,
  createDefaultConfig,
} from 'modules/common/viewer/pdfViewer/interactions/annotationModeConfig';

/**
 * Standalone File Viewer mode config.
 *
 * The SFV has no apps panel — all extraction types are always visible
 * with default styling and whiteout enabled.
 */
export const SFV_MODE_CONFIG: AnnotationModeConfig = createDefaultConfig(
  true,
  () => DEFAULT_DISPLAY_STATE,
);
